import styled from 'styled-components';

export const Content = styled.div`
  color: ${(props) => props.theme.$black};

  .min-width-0 {
    min-width: 0;
  }

  .meta-section {
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid ${(props) => props.theme.$gray300};
  }

  .meta-label {
    font-weight: 700;
  }

  .objeto-text {
    white-space: pre-line;
  }

  .item-block {
    background: ${(props) => props.theme.$gray100};
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 8px;
    padding: 0 1.5rem;
  }

  .item-section {
    padding: 1.25rem 0;

    & + .item-section {
      border-top: 1px solid ${(props) => props.theme.$gray300};
    }
  }

  .item-title {
    font-weight: 700;
    margin-bottom: 0.25rem;
  }

  .company-link {
    padding: 0;
    border: 0;
    text-align: left;
    vertical-align: baseline;
  }

  .participants-table {
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 8px;

    th,
    td {
      padding: 0.85rem 0.75rem;
      vertical-align: middle;
    }

    th:first-child,
    td:first-child {
      padding-left: 1.25rem;
    }

    th:last-child,
    td:last-child {
      padding-right: 1.25rem;
    }

    .participant-name {
      min-width: 220px;
    }

    .participant-badges .badge {
      font-weight: 600;
    }

    th {
      background: ${(props) => props.theme.$gray200};
      border-top: 0;
      border-bottom: 1px solid ${(props) => props.theme.$gray400};
      white-space: nowrap;
    }

    .rejections-title {
      padding: 1rem 1.25rem;
      font-weight: 700;
      background: ${(props) => props.theme.$gray200};
      border-bottom: 1px solid ${(props) => props.theme.$gray400};
      border-radius: 8px 8px 0 0;
    }

    .rejections-title + .table-responsive thead th {
      border-radius: 0;
    }

    .rejection-badge {
      color: ${(props) => props.theme.$danger_border_strong};
      background: ${(props) => props.theme.$danger_light_bg};
      border: 1px solid ${(props) => props.theme.$danger_border_strong};
    }

    .rejection-reason {
      min-width: 280px;
    }

    thead th:first-child {
      border-top-left-radius: 8px;
    }

    thead th:last-child {
      border-top-right-radius: 8px;
    }
  }
`;
